import { render, staticRenderFns } from "./PayMoney.vue?vue&type=template&id=772faf65&scoped=true"
import script from "./PayMoney.vue?vue&type=script&lang=js"
export * from "./PayMoney.vue?vue&type=script&lang=js"
import style0 from "./PayMoney.vue?vue&type=style&index=0&id=772faf65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772faf65",
  null
  
)

export default component.exports